export enum ICardMasterEnum {
  // RejectionStatus = 'Card Rejection Status',
  Type = 'Card Type',
  CardStatus = 'Card Status',
}
